module.exports = __webpack_public_path__ + "fonts/d14d79c.ttf";